export default __webpack_public_path__ + "static/media/view-details.f58e367e.svg";